export const MODIFIERS_V2 = 'modifiers_v2';
export const FOCAL_POINT_IMAGES = 'focal_point_images';
export const DESIGN_AND_CUSTOMIZATION_OO = 'design_and_customization_oo';
export const DESIGN_AND_CUSTOMIZATION_CATERING =
  'catering_design_and_customization';

export const MENUUPSELLS = 'menu_upsells';
